import { useEffect, useState } from "react";
import { motion } from "framer-motion";

import { MAYA } from "../../lib/demoContent";
import { SceneCaption } from "./SceneCaption";

const Typed = ({ text, delay = 0, speed = 28 }) => {
  const [shown, setShown] = useState("");
  useEffect(() => {
    let cancelled = false;
    const start = setTimeout(() => {
      let i = 0;
      const tick = () => {
        if (cancelled) return;
        i += 1;
        setShown(text.slice(0, i));
        if (i < text.length) setTimeout(tick, speed);
      };
      tick();
    }, delay * 1000);
    return () => {
      cancelled = true;
      clearTimeout(start);
    };
  }, [text, delay, speed]);
  return (
    <span>
      {shown}
      {shown.length < text.length && (
        <span className="inline-block w-[1px] h-[1em] align-text-bottom bg-[#C4521E] ml-0.5 animate-pulse" />
      )}
    </span>
  );
};

/** Scene 3 — Maya loads her context. Caption + two notebook cards that type in. */
export const ScreenContext = () => (
  <div className="max-w-4xl" data-testid="demo-scene-context">
    <SceneCaption
      eyebrow="The context"
      body="She gave it her product, and the feature she was thinking about."
    />

    <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-5">
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.8 }}
        className="border border-[#DDD9CF] bg-white rounded-md p-6 xl:p-7 min-h-[180px]"
      >
        <div className="text-[10px] uppercase tracking-[0.20em] text-[#C4521E] mb-3">
          The product
        </div>
        <p className="text-base xl:text-lg text-[#1A1814] leading-relaxed font-serif-display">
          <Typed text={MAYA.context} delay={1.1} speed={18} />
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 1.0 }}
        className="border border-[#DDD9CF] bg-white rounded-md p-6 xl:p-7 min-h-[180px]"
      >
        <div className="text-[10px] uppercase tracking-[0.20em] text-[#C4521E] mb-3">
          The feature
        </div>
        <p className="text-base xl:text-lg text-[#1A1814] leading-relaxed font-serif-display">
          <Typed text={MAYA.featureBrief} delay={4.4} speed={18} />
        </p>
      </motion.div>
    </div>
  </div>
);
